import { SettingsDataObject } from '@next/core-lib/settings';
import { FeedAdviceType } from 'src/app/feed-advice/models/feed-advice.model';

import { EnergySystem, LysineSystem } from '../../settings/models/settings.model';

export interface Product extends SettingsDataObject {
  id: number;
  code: string;
  name: string;
  suitablePhases: number[];
  ewKg: number;
  lysKg: number;
  customerId?: number;
  country?: string;
  energySystem: EnergySystem;
  lysineSystem: LysineSystem;
  unitNettoPrice?: number;
  currency?: string;
  schemeTypes: FeedAdviceType[];
  grossPricePer100Kg?: number;
  phosphorusGramPerKg?: number;
  proteinGramPerKg?: number;
}

export enum PigContextKeys {
  CONTEXT = 'pig',
  SELECTED_PRODUCT_COUNTRY = 'selectedProductCountry',
  SELECTED_REFERENCEFEEDADVICE_COUNTRY = 'selectedSchemeReferenceCountry',
  SELECTED_FEEDADVICE_TYPES = 'selectedFeedadviceTypes',
  UOM_ENERGY_SYSTEM = 'energy',
  UOM_LYSINE_SYSTEM = 'lysine',
  SHOW_LYSINE_SETTING = 'showLysineSetting',
  SHOW_ENERGY_SETTING = 'showEnergySetting',
  SHOW_DOSATOR_SETTING = 'showDosatorSetting',
}

export enum ViewMode {
  VIEW = 'View',
  EDIT = 'Edit',
  CREATE = 'Create',
}
